import { NavLink } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

/** Compact nav + sign-out for list/detail/knowledge shells. */
export function AuthBar() {
  const { user, signOutUser } = useAuth()
  if (!user) return null
  return (
    <div className="auth-bar">
      <nav className="auth-nav" aria-label="Operator">
        <NavLink to="/" end className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
          Todos
        </NavLink>
        <NavLink
          to="/knowledge"
          className={({ isActive }) => (isActive ? 'is-active' : undefined)}
        >
          Knowledge
        </NavLink>
        <NavLink
          to="/discovery"
          className={({ isActive }) => (isActive ? 'is-active' : undefined)}
        >
          Discovery
        </NavLink>
        {import.meta.env.DEV ? (
          <NavLink
            to="/previews"
            className={({ isActive }) => (isActive ? 'is-active' : undefined)}
          >
            Previews
          </NavLink>
        ) : null}
        <NavLink
          to="/account"
          className={({ isActive }) => (isActive ? 'is-active' : undefined)}
        >
          Account
        </NavLink>
      </nav>
      <span className="auth-email" title={user.email ?? undefined}>
        {user.email}
      </span>
      <button type="button" className="auth-out" onClick={() => void signOutUser()}>
        Sign out
      </button>
    </div>
  )
}
